import * as AuditModels from './AuditModel';

import { getJson } from '../../lib/ChoiceApi';

export const audit = {
    async getAuditInfo(identifierId: number, screenName: string): Promise<AuditModels.IChoiceAuditResponse[]> {
        return await getJson(`api/ChoiceAudit/ListAudit/${identifierId}/${screenName}`) as AuditModels.IChoiceAuditResponse[];
    },

}